import React from "react";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";

const GameProfileSkeleton = () => {
  const deviceSize = useDeviceSize();

  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "center",
        marginLeft: 25,
      }}
    >
      <Skeletons
        height={27}
        width={"120px"}
        style={{
          marginBottom: 20,
        }}
      />

      <Skeletons
        height={223}
        width={"190px"}
        style={{
          borderRadius: 10,

          borderWidth: 0,

          padding: 10,
          verticalAlign: "top",
        }}
      />
    </View>
  );
};

export default GameProfileSkeleton;
